import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../ui/dialog';

const Stat = ({ value, label, tone = 'neutral' }) => {
  const tones = {
    neutral: ['bg-neutral-50', 'text-neutral-700'],
    good: ['bg-emerald-50', 'text-emerald-700'],
    bad: ['bg-red-50', 'text-red-700'],
  }[tone];
  return (
    <div className={`rounded-lg p-3 ${tones[0]}`}>
      <p className={`text-2xl font-bold ${tones[1]}`}>{value}</p>
      <p className="text-xs text-neutral-600">{label}</p>
    </div>
  );
};

export const AuditResultsDialog = ({ result, onClose }) => (
  <Dialog open={!!result} onOpenChange={onClose}>
    <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto" data-testid="audit-results-dialog">
      <DialogHeader>
        <DialogTitle>Color Audit Results</DialogTitle>
      </DialogHeader>
      {result && (
        <div className="space-y-4 py-2">
          <div className="grid grid-cols-3 gap-3 text-center">
            <Stat value={result.matches} label="Matching" tone="good" />
            <Stat value={result.mismatch_count} label="Mismatches" tone={result.mismatch_count > 0 ? 'bad' : 'neutral'} />
            <Stat value={result.total_scanned} label="Total Scanned" />
          </div>
          {result.missing_cdn_url > 0 && <p className="text-xs text-amber-600">Missing CDN URL: {result.missing_cdn_url} colors</p>}
          {result.cdn_unreachable > 0 && <p className="text-xs text-red-600">CDN unreachable: {result.cdn_unreachable} colors</p>}
          {result.mismatches?.length > 0 && (
            <div>
              <h4 className="font-semibold text-sm mb-2">Mismatched Colors:</h4>
              <div className="space-y-2 max-h-60 overflow-y-auto">
                {result.mismatches.map((m, i) => (
                  <div key={i} className="bg-red-50 rounded p-2 text-xs">
                    <p className="font-medium">{m.code} - {m.name}</p>
                    <p className="text-neutral-500">Material: {m.material}</p>
                    <p className="text-red-600">{m.reason === 'size_mismatch' ? `Size mismatch: CDN ${m.cdn_size}B vs Stored ${m.stored_size}B` : m.reason}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default AuditResultsDialog;
